import React, { createContext, useContext, useState, useEffect } from "react";
import { getUserFirstLast } from "../../api/auth";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        const response = await getUserFirstLast();
        const data = response?.data;
        const msg = data?.message;
        const isValid =
          msg !== "token is invalid" && msg !== "a valid token is missing";

        if (isValid) {
          setUser(data || null);
          setIsUserLoggedIn(true);
        } else {
          localStorage.setItem("user", "");
          setUser(null);
          setIsUserLoggedIn(false);
        }
      } catch (error) {
        localStorage.setItem("user", "");
        setUser(null);
        setIsUserLoggedIn(false);
      } finally {
        setLoading(false);
      }
    };
    checkUserStatus();
  }, []);

  // Inactivity timeout — auto-logout after 10 minutes
  useEffect(() => {
    if (process.env.REACT_APP_DISABLE_AUTOLOGOUT === "true") return;
    try {
      let timer;
      const resetTimer = () => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          localStorage.setItem("user", "");
          setUser(null);
          setIsUserLoggedIn(false);
        }, 600_000);
      };
      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keypress", resetTimer);
      window.addEventListener("scroll", resetTimer);
      resetTimer();
      return () => {
        if (timer) clearTimeout(timer);
        window.removeEventListener("mousemove", resetTimer);
        window.removeEventListener("keypress", resetTimer);
        window.removeEventListener("scroll", resetTimer);
      };
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isUserLoggedIn,
        setIsUserLoggedIn,
        loading,
        user,
        setUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export default AuthContext;
